import { createAction } from "@reduxjs/toolkit";

const setClosedWebSocket = createAction("SET_CLOSED_WEBSOCKET");
export default setClosedWebSocket;
